import api from "Common/Client/Interceptor";

// Skills inventory management for the Tenant Admin.
// Skills are the shared inventory used by Courses, Learners and Mentor profiles.

export const fetchBusinessGroups = async () => {
  // Business-group selector: use the full lookup, not the paginated list.
  const response = await api.get("/BusinessGroup/Lookup");
  return response.data;
};

export const fetchSkillsByBusinessGroup = async (businessGroupId) => {
  // Full skills list for a group (management view): use the lookup.
  const response = await api.get(`/Skills/businessgroup/${businessGroupId}/Lookup`);
  return response.data;
};

// Add one or more skill names to a business group.
// Note: the backend field is spelled "buisnessGroupId" (as-is), keep it.
export const addSkillsByBusinessGroup = async (businessGroupId, skills) => {
  const response = await api.post("/Skills/AddList-By-BusinessGroup", {
    buisnessGroupId: businessGroupId,
    skills,
  });
  return response.data;
};

export const updateSkill = async (skillId, name) => {
  const response = await api.put(`/Skills/${skillId}`, { name });
  return response.data;
};

export const deleteSkill = async (skillId) => {
  const response = await api.delete(`/Skills/${skillId}`);
  return response.data;
};
